import { render, staticRenderFns } from "./BindZsk.vue?vue&type=template&id=c134a47c&scoped=true&"
import script from "./BindZsk.vue?vue&type=script&lang=js&"
export * from "./BindZsk.vue?vue&type=script&lang=js&"
import style0 from "./BindZsk.vue?vue&type=style&index=0&id=c134a47c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c134a47c",
  null
  
)

export default component.exports